/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { NavLink, NavLinkProps } from '@mantine/core'
import { useLocation } from 'react-router'
import { Link, LinkProps } from 'react-router-dom'
import { useMemo } from 'react'
import { useHover } from '@mantine/hooks'

export type NavLinkItemProps = NavLinkProps & LinkProps

function getPath (url: string) {
  const index = url.indexOf('?')
  return index !== -1 ? url.substring(0, index) : url
}

function NavLinkItem (props: NavLinkItemProps) {
  const {
    children,
    to,
    ...others
  } = props

  const location = useLocation()
  const { ref } = useHover<HTMLAnchorElement>()

  const active = useMemo(() => (
    String(to) === location.pathname ||
    (String(to) !== '/' && location.pathname.startsWith(getPath(String(to))))
  ), [location.pathname, to])

  return (
    <NavLink
      active={active}
      component={Link}
      ref={ref}
      to={to}
      childrenOffset="xs"
      {...others}
    >
      {children}
    </NavLink>
  )
}

export default NavLinkItem
